<pathPantalla></pathPantalla>

<!-- Filtros -->
<div class="row">
    <div class="col-lg-12" style="padding: 0px">
        <section class="widget">
            <!-- título -->
            <header>
                <h3> {{sistemaService.NombrePantallaActual}} </h3>
            </header>
            <div class="separador"></div>
            <filtros (filtroAplicado)="SetDatos($event)" [filtros]="filtrosDisplay" [urlApi]="uriApi" [verBotonConsultar]="false" #filtrosComponent></filtros>
        </section>
    </div>
</div>

<div class="divisor8"></div>

<div class="row">
    <div class="col-lg-12" style="padding: 0px">
        <section class="widget">
            <!-- tabla -->
            <div>

                <!-- Agregar  -->
                <div>
                    <button class="btn boton botonXS" (click)="Modal()" *ngIf="sistemaService.permisos.agregar">
                        <span class="fa fa-plus"></span>
                        <span> {{'Agregar'}}</span>
                    </button>
                </div>

                <div class="divisor16"></div>

                <!-- datos -->
                <dx-data-grid
                    (onOptionChanged)="sistemaService.CambiarPaginacionTabla($event)"
                    id="tabla"
                    [columnAutoWidth]="true"
                    [dataSource]="dataTable"
                    [showColumnHeaders]="true"
                    >
                    <dxo-export [enabled]="true" [fileName]="sistemaService.NombrePantallaActual" *ngIf="sistemaService.permisos.exportar"></dxo-export>

                    <dxo-search-panel
                        [visible]="true"
                        [width]="240"
                        placeholder="{{'Buscar' | translate}}">
                    </dxo-search-panel>

                    <dxo-paging [pageSize]="sistemaService.tablaPaginacion"></dxo-paging>
                    <!--<dxo-scrolling mode="virtual" [useNative]="false" [showScrollbar]="'always'"></dxo-scrolling>-->

                    <dxo-pager
                        [visible]="true"
                        [allowedPageSizes]="sistemaService.tablaPaginacionPaginaSize"
                        [displayMode]="sistemaService.tablaPaginacionModo"
                        [showPageSizeSelector]="sistemaService.tablaPaginacionSelector"
                        [showInfo]="sistemaService.tablaPaginacionInfo"
                        [showNavigationButtons]="sistemaService.tablaPaginacionNavegacion">
                    </dxo-pager>

                    <dxi-column
                        [allowExporting]="false"
                        caption="Acciones"
                        cellTemplate="cellAcciones"
                        alignment="center">

                    </dxi-column>
                    <dxi-column
                        dataField="nombre"
                        caption="Nombre">
                    </dxi-column>
                    <dxi-column
                        dataField="activo"
                        caption="Activo"
                        cellTemplate="cellActivo"
                        [calculateCellValue]="sistemaService.GetValorActivo"
                        alignment="center">
                    </dxi-column>

                    <!-- Activo -->
                    <div *dxTemplate="let cell of 'cellActivo'" class="iconoActivo">
                        <span *ngIf="cell.data.activo" class="fa fa-check-square-o"></span>
                        <span *ngIf="!cell.data.activo" class="fa fa-square-o"></span>
                    </div>
                    <!-- Acciones -->
                    <div *dxTemplate="let cell of 'cellAcciones'">
                        <a matTooltip="Editar" class="tablaBoton edit" (click)="Editar(cell.data)" *ngIf="sistemaService.permisos.editar">
                            <i class="fa fa-pencil fa-lg" aria-hidden="true"></i>
                        </a>
                        <a matTooltip="Eliminar" class="tablaBoton separado delete" (click)="Eliminar(cell.data)" *ngIf="sistemaService.permisos.eliminar">
                            <i class="fa fa-trash fa-lg" aria-hidden="true"></i>
                        </a>
                    </div>

                </dx-data-grid>

            </div>
        </section>
    </div>
</div>

<ng-container *ngIf="abierto">
    <div class="backdrop"></div>
    <div class="modalPanelAdmin animated {{animacion}}">

        <div class="contenido">
            <!-- Título -->
            <div class="encabezadoModal">
                <div class="modalTituloSimple">
                    {{(entidad.escalaevaluacionid == 0 ? 'Agregar' : 'Editar')}}
                </div>
            </div>
            <div class="modalContenido">
                <!-- datos -->
                <div>
                    <div class="divisor8"></div>
                    <div>
                        <!-- Datos generales -->
                        <div class="row">
                            <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                                <inputCustom [titulo]="'Nombre'" [(ngModel)]="entidad.nombre" [errorActivo]="errorActivo"></inputCustom>
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                                <checkBoxCustom [titulo]="'Activo'" [alineacion]="1" [(ngModel)]="entidad.activo"></checkBoxCustom>
                            </div>
                        </div>
                        <div class="row">

                            <div>
                                <button class="btn boton botonXS" (click)="Modal2()">
                                    <span class="fa fa-plus"></span>
                                    <span> {{'Agregar'}}</span>
                                </button>
                            </div>

                            <div class="divisor16"></div>
                            <!-- datos -->
                            <dx-data-grid
                                (onOptionChanged)="sistemaService.CambiarPaginacionTabla($event)"
                                id="tabla"
                                [columnAutoWidth]="true"
                                [dataSource]="dataTable2"
                                [showColumnHeaders]="true"
                                >

                                <dxi-column
                                    [allowExporting]="false"
                                    caption="Acciones"
                                    cellTemplate="cellAcciones"
                                    alignment="center">
                                </dxi-column>
                                <dxi-column
                                    dataField="nombre"
                                    caption="Opción">
                                </dxi-column>
                                <dxi-column
                                    dataField="descripcion"
                                    caption="Descripción"
                                    [width]="400">
                                </dxi-column>
                                <dxi-column
                                    dataField="valor"
                                    caption="Valor">
                                </dxi-column>
                                <dxi-column
                                    dataField="color"
                                    caption="Color"
                                    cellTemplate="cellColor"
                                    alignment="center">
                                </dxi-column>
                                <dxi-column
                                    dataField="icono"
                                    caption="Icono"
                                    cellTemplate="cellIcono"
                                    alignment="center">
                                </dxi-column>
                                <dxi-column
                                    dataField="activo"
                                    caption="Activo"
                                    cellTemplate="cellActivo"
                                    [calculateCellValue]="sistemaService.GetValorActivo"
                                    alignment="center">
                                </dxi-column>


                                <!-- Descripcion -->
                                <!--<div *dxTemplate="let cell of 'cellDescripcion'">
                                    {{ (cell.data.descripcion.length>100)? (cell.data.descripcion | slice:0:100)+'...':(cell.data.descripcion) }}
                                </div>-->
                                <!-- Color -->
                                <div *dxTemplate="let cell of 'cellColor'">
                                    <input type="color" disabled  value="{{cell.data.color}}">
                                </div>
                                <!-- Icono -->
                                <div *dxTemplate="let cell of 'cellIcono'">
                                    <div class="icon">
                                        <img style="height: 29px; width: 29px;" *ngIf="cell.data.icono" [src]="cell.data.icono | Base64Seguro">
                                    </div>
                                </div>
                                <!-- Activo -->
                                <div *dxTemplate="let cell of 'cellActivo'" class="iconoActivo">
                                    <span *ngIf="cell.data.activo" class="fa fa-check-square-o"></span>
                                    <span *ngIf="!cell.data.activo" class="fa fa-square-o"></span>
                                </div>
                                <!-- Acciones -->
                                <div *dxTemplate="let cell of 'cellAcciones'">
                                    <a matTooltip="Editar" class="tablaBoton edit" (click)="Editar2(cell)">
                                        <i class="fa fa-pencil fa-lg" aria-hidden="true"></i>
                                    </a>
                                    <a matTooltip="Eliminar" class="tablaBoton separado delete" (click)="Eliminar2(cell)">
                                        <i class="fa fa-trash fa-lg" aria-hidden="true"></i>
                                    </a>
                                </div>

                            </dx-data-grid>
                        </div>
                    </div>
                </div>

            </div>

            <!-- footer -->
            <div class="modalFooter">
                <div class="contenidoFooter botonesIzq">
                    <!-- editar -->
                    <div class="botonDerecha">
                        <button class="boton botonSM filledBlanco" (click)="CerrarModal()">
                            {{'Cancelar' | translate}}
                        </button>
                        <div class="divisorH16"></div>
                        <button class="boton botonSM filled" (click)="Guardar()">
                            {{'Guardar' | translate}}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="abierto2">
    <div class="backdrop"></div>
    <div class="modalPanelAdmin animated {{animacion2}}">

        <div class="contenido">
            <!-- Título -->
            <div class="encabezadoModal">
                <div class="modalTituloSimple">
                    {{(entidad2.escalaevaluacionvalorid == 0 ? 'Agregar' : 'Editar')}}
                </div>
            </div>
            <div class="modalContenido">
                <!-- datos -->
                <div>
                    <div class="divisor8"></div>
                    <div>
                        <!-- Datos generales -->
                        <div class="row">
                            <div class="col-lg-6 col-md-6 col-sm-6 col-6" data-toggle="tooltip" data-html="true" data-placement="top" title="Valor a ingresar a la evaluación.">
                                <inputCustom [titulo]="'Opción'" [(ngModel)]="entidad2.nombre" [errorActivo]="errorActivo2"></inputCustom>
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-12 col-12" data-toggle="tooltip" data-placement="top" title='Color con el que aparece la opción de la escala &#13;de evaluación en el "Reporte de evaluación".'>
                                <colorPicker [titulo]="'Color (RGB/Hex)'" [(ngModel)]="entidad2.color" [errorActivo]="errorActivo2"></colorPicker>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                                <textareaCustom [titulo]="'Descripción'" [(ngModel)]="entidad2.descripcion" [errorActivo]="errorActivo2"  data-toggle="tooltip" data-placement="top" title='Descripción relacionada a la opción &#13;que se desea agregar.'></textareaCustom>
                                <!-- <inputCustom [titulo]="'Valor para ponderación'" [(ngModel)]="entidad2.valor" [verError]="false"  data-toggle="tooltip" data-placement="top" title='El valor para ponderación que será tomado en cuenta para algún &#13;reporte que requiera ponderar las opciones de respuestas.'></inputCustom> -->

                                <div [ngClass]="{'row' : entidad2.icono}">
                                    <div *ngIf="entidad2.icono" class="col-lg-2 col-md-3 col-sm-3 col-2">
                                        <div class="icon">
                                            <img style="height: 29px; width: 29px;" [src]="entidad2.icono | Base64Seguro">
                                                 <!--<button (click)="entidad2.icono = null" class="btnTimes" tabindex="-1" style="position: absolute;">
                                                 <span class="fa fa-times"></span>
                                                </button>-->
                                        </div>
                                    </div>
                                    <div [ngClass]="entidad2.icono ? 'col-lg-10 col-md-9 col-sm-9 col-10' : ''" data-toggle="tooltip" data-placement="top" title='Permite agregar una imagen.'>
                                        <fileCustom [titulo]="'Icono'" [fileSave]="entidad2.icono ? true:false" [mimeTypeAceptado]="'image/*'" (archivoSeleccionado)="entidad2.icono = $event?.Archivo"  [verError]="false"></fileCustom>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                                <div class="row">
                                    <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                                        <div class="row">
                                            <div class="col-lg-12 col-md-12 col-sm-12 col-12">
                                                <checkBoxCustom [titulo]="'Mostrar imagen'" [alineacion]="1" [(ngModel)]="entidad2.mostrarimagen" data-toggle="tooltip" data-placement="top" title='Indicar para mostrar la imagen durante &#13;la evaluación.'></checkBoxCustom>
                                                <checkBoxCustom [titulo]="'Mostrar texto'" [alineacion]="1" [(ngModel)]="entidad2.mostrartexto" data-toggle="tooltip" data-placement="top" title='Indicar para mostrar el nombre de la &#13;opción durante la evaluación.'></checkBoxCustom>
                                                <checkBoxCustom [titulo]="'Mostrar descripción'" [alineacion]="1" [(ngModel)]="entidad2.mostrardescripcion" data-toggle="tooltip" data-placement="top" title='Indicar para mostrar la descripción &#13;durante la evaluación.'></checkBoxCustom>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                                        <div class="row">
                                            <div class="col-lg-12 col-md-12 col-sm-12 col-12">
                                                <checkBoxCustom [titulo]="'Incluir en cálculos de %'" [alineacion]="1" [(ngModel)]="entidad2.incluircalculo" data-toggle="tooltip" data-placement="top" title='Indica si el campo será considerado&#13;para la estadística de respuestas.'></checkBoxCustom>
                                                <checkBoxCustom [titulo]="'Activo'" [alineacion]="1" [(ngModel)]="entidad2.activo" data-toggle="tooltip" data-placement="top" title='Indica si la opción es visible durante&#13;la evaluación.'></checkBoxCustom>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <!-- footer -->
            <div class="modalFooter">
                <div class="contenidoFooter botonesIzq">
                    <!-- editar -->
                    <div class="botonDerecha">
                        <button class="boton botonSM filledBlanco" (click)="CerrarModal2()">
                            {{'Cancelar' | translate}}
                        </button>
                        <div class="divisorH16"></div>
                        <button class="boton botonSM filled" (click)="Guardar2()">
                            {{'Guardar' | translate}}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>
